import { MapPin } from "lucide-react";

import GetDirectionsButton from "@/components/shared/buttons/get-directions-button";
import CopyToClipboardButton from "@/components/shared/copy-to-clipboard-button";
import { directionAndShareButtonsTestIds } from "@/lib/data-test-ids/jobs.data-test-ids";

export interface DirectionAndShareButtonsProps {
  directionsUrl: string | undefined;
  shareUrl: string | undefined;
  entityId: string;
}

const buttonClassName =
  "flex items-center justify-start gap-3 w-full h-auto px-3 py-2.5 rounded-lg border border-border hover:bg-surface-subtle transition-colors text-sm font-normal";

function LabelContent({
  label,
  subLabel,
}: {
  label: string;
  subLabel: string;
}) {
  return (
    <div className="flex flex-col text-left">
      <span className="text-foreground font-medium">{label}</span>
      <span className="text-xs text-ink-subtle">{subLabel}</span>
    </div>
  );
}

export function ShareButton({
  shareUrl,
  entityId,
  label,
}: {
  shareUrl: string;
  entityId: string;
  label: string;
}) {
  return (
    <CopyToClipboardButton
      hoverTooltip="Share"
      testId={`${directionAndShareButtonsTestIds.SHARE_BUTTON}-${entityId}`}
      successTooltip="URL copied to clipboard!"
      textToCopy={shareUrl}
      buttonVariant="text"
      className={buttonClassName}
    >
      <LabelContent label={label} subLabel="Copy link to clipboard" />
    </CopyToClipboardButton>
  );
}

export function DirectionAndShareButtons({
  directionsUrl,
  shareUrl,
  entityId,
}: DirectionAndShareButtonsProps) {
  return (
    <div
      className="flex flex-col gap-2"
      data-testid={`${directionAndShareButtonsTestIds.CONTAINER}-${entityId}`}
    >
      {directionsUrl && (
        <GetDirectionsButton
          icon={<MapPin className="w-4 h-4" />}
          directionsUrl={directionsUrl}
          testId={`${directionAndShareButtonsTestIds.GET_DIRECTIONS_BUTTON}-${entityId}`}
          className={buttonClassName}
        >
          <LabelContent label="Get directions" subLabel="Open in Maps" />
        </GetDirectionsButton>
      )}
      {shareUrl && (
        <ShareButton
          shareUrl={shareUrl}
          entityId={entityId}
          label="Share school"
        />
      )}
    </div>
  );
}
